(ns web3.tracking.segment
  (:require [web3.persistence.queries :as q]
            [web3.persistence.graphql :as g]
            [web3.tracking.mixpanel :as mix]
            [cljs.core.async :refer [go go-loop chan put! close! <! >! timeout]]
            [re-frame.core :as rf]
            [web3.log :as log]
            [web3.env :as env]
            [goog.object :as gobj]
            [re-frame-simple.db :as db]
            [web3.utils :as utils]
            [kitchen-async.promise :as p]
            [applied-science.js-interop :as j]
            [web3.utils :as utils]
            [clojure.set :as set]
            [web3.queries.root :as q-root]
            [web3.routing.utils :as r-utils]))

(def SEGMENT_ID (env/config :SEGMENT_ID nil))

(def events-delayed? (atom true))

(def event-ch (chan 100))

(defn ^js analytics
  []
  (j/get js/window :analytics))

(defn analytics-ready []
  (p/promise [resolve reject]
    (.ready (analytics) #(resolve nil))))

(defn identify
  ([user-id]
   (identify user-id nil nil nil))
  ([user-id traits]
   (identify user-id traits nil nil))
  ([user-id traits options]
   (identify user-id traits options nil))
  ([user-id traits options cb]
   (.identify (analytics)
              user-id
              (clj->js traits)
              (clj->js options)
              cb)))

(defn add-context
  [m]
  (let [context
        (db/get :web3.tracking.components/event-context)

        property
        (let [{:keys [id address]} (:web3.screens.root/current-property context)]
          (-> (assoc address :id id)
              (set/rename-keys {:locality :state
                                :region :city})
              (->> (utils/map-keys #(keyword "property" (name %))))))

        asset
        (utils/map-keys #(keyword "asset" (name %))
                        (:web3.screens.asset/current-asset context))]

    (utils/->js-map (merge m property asset))))

(defn init!
  []

  (when (:SEGMENT_ID env/config)
    (p/do (analytics-ready)
          (let [anon-id (mix/get-distinct-id)]
            (.. (analytics) (user) (anonymousId anon-id)))))
  (g/once q-root/me
          nil
          {:on-complete #(let [query (js->clj % :keywordize-keys true)
                               {:keys [id firstName lastName
                                       email website companyName] :as me} (-> query :data :me)

                               traits {:firstName firstName
                                       :lastName lastName
                                       :email email
                                       :website website
                                       :company companyName}]
                           (p/do (p/timeout 15000)
                                 (do
                                   (log/info "Sending events")
                                   (reset! events-delayed? false)
                                   (identify id traits nil)
                                   (go-loop []
                                            (let [e (<! event-ch)
                                                  [event-name props] e]
                                              (when-not (map? props)
                                                (log/warn event-name " has props that aren't a map:\n" props))
                                              (.track (analytics) event-name (add-context props))
                                              (recur))))))}))

(defn logout!
  []
  (p/do (analytics-ready)
        (mix/reset!)
        (.reset (analytics))))

(rf/reg-fx ::logout
  (fn [] (logout!)))

(rf/reg-fx ::init
  (fn [] (init!)))

(defn event! [event-name props]
  (put! event-ch [event-name (merge props {:delayed @events-delayed?})]))

(rf/reg-fx ::event!
  (fn [[event-name props]]
    (log/println :debug :tracking.mixpanel/event! event-name)
    (event! event-name props)))

(rf/reg-event-fx ::event
  (fn [_ [_ event-name props]]
    {::event! [event-name props]}))
